import { getConfigurations } from 'api/configurations';
import Image from 'components/Image';
import MKBox from 'components/MaterialKit/MKBox';
import { useAuth } from 'contexts/auth';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import TextSection from 'sections/Text';
import { handleErrorResponse } from 'utils/general';

const HK1_HEARTBEAT_ID = '0196a9b7-c2ba-71f1-81c7-c06f17e2926e';
const HK2_HEARTBEAT_ID = '0196a9b9-e570-71f0-a253-ed8db91c7c3e';
const JP_HEARTBEAT_ID = '0196a9b9-ee4d-73e0-aae0-7a9c8ca57650';

const TrackingDashboardHeaderSection = ({ title, datetime_format, color, font_size, font_weight, left_logo_url, right_logo_url, background_color, datetime_font_size, ...props }) => {
  const [datetime, setDatetime] = useState('');
  const [hk1HearBeat, setHk1HeartBeat] = useState();
  const [hk2HearBeat, setHk2HeartBeat] = useState();
  const [jpHearBeat, setJpHeartBeat] = useState();
  const { setAuth } = useAuth();

  useEffect(() => {
    if (datetime_format) {
      const interval = setInterval(() => {
        setDatetime(moment().format(datetime_format));
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [datetime_format]);

  const fetchCongifurationsFromApi = useCallback(() => {
    const params = {
      'configuration_id[in]': `${HK1_HEARTBEAT_ID},${HK2_HEARTBEAT_ID},${JP_HEARTBEAT_ID}`,
    }
    return getConfigurations(params)
      .then(({ data }) => {
        data.forEach((datum) => {
          if (datum.configuration_id === HK1_HEARTBEAT_ID) {
            setHk1HeartBeat(datum.fix_value);
          } else if (datum.configuration_id === HK2_HEARTBEAT_ID) {
            setHk2HeartBeat(datum.fix_value);
          } else if (datum.configuration_id === JP_HEARTBEAT_ID) {
            setJpHeartBeat(datum.fix_value);
          }
        });
      })
      .catch((error) => {
        handleErrorResponse(error, setAuth);
      })
      .finally(() => {
        // setLoading(false);
      });
  }, [setAuth]);

  useEffect(() => {
    fetchCongifurationsFromApi();
  }, [fetchCongifurationsFromApi]);

  return (
    <MKBox
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{ backgroundColor: background_color }}
      {...props}
    >
      <Image src={left_logo_url} />
      <TextSection
        text={title}
        color={color}
        font_size={font_size}
        font_weight={font_weight}
      />
      <MKBox
        display="flex"
        alignItems="center"
      >
        <MKBox display="flex" flexDirection="column">
          {hk1HearBeat && (
            <TextSection
              text={`HK1: ${hk1HearBeat}`}
              color={color}
              font_size={datetime_font_size}
              font_weight={font_weight}
              textAlign="left"
            />
          )}
          {hk2HearBeat && (
            <TextSection
              text={`HK2: ${hk2HearBeat}`}
              color={color}
              font_size={datetime_font_size}
              font_weight={font_weight}
              textAlign="left"
            />
          )}
          {jpHearBeat && (
            <TextSection
              text={`JP: ${jpHearBeat}`}
              color={color}
              font_size={datetime_font_size}
              font_weight={font_weight}
              textAlign="left"
            />
          )}
        </MKBox>
        <Image src={right_logo_url} style={{ marginLeft: '1rem' }} />
      </MKBox>
    </MKBox>
  );
};

TrackingDashboardHeaderSection.propTypes = {
  datetime_format: PropTypes.string,
  color: PropTypes.string,
  font_size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  font_weight: PropTypes.string,
  left_logo_url: PropTypes.string,
  right_logo_url: PropTypes.string,
  background_color: PropTypes.string,
  title: PropTypes.string,
  datetime_font_size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default TrackingDashboardHeaderSection;
